module.exports = __webpack_public_path__ + "static/media/Screenshot--playlist.b26edc10.png";